import React, { useState } from 'react';

function Support() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    storeId: '',
    issueType: '',
    priority: 'medium',
    subject: '',
    description: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // TODO: Integrate with your ticketing system or email service
    console.log('Support Ticket Submitted:', formData);
    
    // For now, just show success message
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        storeId: '',
        issueType: '',
        priority: 'medium',
        subject: '',
        description: ''
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="support">
      <div className="pricing-container">
        <h1 className="section-title">Technical Support</h1>
        <p className="section-subtitle">
          Having trouble with Invex? Submit a support ticket and our team will assist you as soon as possible.
        </p>

        <div className="form-container">
          {submitted && (
            <div className="success-message">
              ✓ Support ticket submitted successfully! We'll contact you within 24 hours. Ticket reference will be sent to your email.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Your Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="storeId">Store ID (if applicable)</label>
              <input
                type="text"
                id="storeId"
                name="storeId"
                value={formData.storeId}
                onChange={handleChange}
                placeholder="Your store ID from the app"
              />
            </div>

            <div className="form-group">
              <label htmlFor="issueType">Issue Type *</label>
              <select
                id="issueType"
                name="issueType"
                value={formData.issueType}
                onChange={handleChange}
                required
              >
                <option value="">Select issue type...</option>
                <option value="login">Login/Authentication Issues</option>
                <option value="pos">POS System Problems</option>
                <option value="inventory">Inventory Management</option>
                <option value="printing">Thermal Printing Issues</option>
                <option value="reports">Reports/Analytics</option>
                <option value="vat">VAT/ZATCA Compliance</option>
                <option value="billing">Billing/Subscription</option>
                <option value="performance">App Performance</option>
                <option value="data">Data Loss/Sync Issues</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="priority">Priority Level *</label>
              <select
                id="priority"
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                required
              >
                <option value="low">Low - General question</option>
                <option value="medium">Medium - Issue affecting workflow</option>
                <option value="high">High - Critical business impact</option>
                <option value="urgent">Urgent - System down/data loss</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject *</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                placeholder="Brief description of the issue"
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">Detailed Description *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                placeholder="Please provide detailed information about the issue, including:
- What you were trying to do
- What happened instead
- Any error messages you saw
- Steps to reproduce the issue"
                style={{ minHeight: '200px' }}
              />
            </div>

            <button type="submit" className="btn-submit">
              Submit Support Ticket
            </button>
          </form>
        </div>

        <div style={{ marginTop: '4rem', background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
          <h3 style={{ color: '#1a3d4d', marginBottom: '2rem', textAlign: 'center' }}>Common Issues & Solutions</h3>
          
          <div style={{ display: 'grid', gap: '2rem' }}>
            <div>
              <h4 style={{ color: '#1fb6a0', marginBottom: '0.5rem' }}>🔐 Can't Login?</h4>
              <p style={{ color: '#718096' }}>
                Make sure you're using the correct email and password. Try the "Forgot Password" feature to reset your password. 
                If you're still having issues, contact us directly.
              </p>
            </div>

            <div>
              <h4 style={{ color: '#1fb6a0', marginBottom: '0.5rem' }}>🖨️ Printer Not Working?</h4>
              <p style={{ color: '#718096' }}>
                Verify that your HZTZ printer is connected to the same WiFi network as your device. 
                Check printer IP address in the app settings and ensure the printer is turned on.
              </p>
            </div>

            <div>
              <h4 style={{ color: '#1fb6a0', marginBottom: '0.5rem' }}>📊 Data Not Syncing?</h4>
              <p style={{ color: '#718096' }}>
                Ensure you have a stable internet connection. Try logging out and logging back in. 
                If the issue persists, submit a support ticket with your Store ID.
              </p>
            </div>

            <div>
              <h4 style={{ color: '#1fb6a0', marginBottom: '0.5rem' }}>💳 Billing Questions?</h4>
              <p style={{ color: '#718096' }}>
                For subscription, payment, or billing inquiries, please email us directly at support@invexapp.com 
                with your account details.
              </p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '3rem', textAlign: 'center' }}>
          <h4 style={{ color: '#1a3d4d', marginBottom: '1rem' }}>Need Immediate Help?</h4>
          <p style={{ color: '#718096', marginBottom: '1.5rem' }}>
            For urgent issues affecting your business operations, email us directly at:
          </p>
          <a href="mailto:support@invexapp.com" className="btn btn-primary">
            support@invexapp.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Support;
